/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const dismiss_keyboard_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 19.857 12 22l-3-2.143M7 14h9.5M3.809 6.508h.37m3.63 0h.372m3.625 0h.37m3.63 0h.372m3.635 0h.371m-2.382 2.998h.371m-4.367 0h.371m-4.362 0h.372m-4.383 0h.371M2 17h20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1ZM3.754 6.508c0-.117.11-.25.254-.25a.23.23 0 0 1 .238.25c-.006.145-.074.242-.238.242-.125 0-.254-.125-.254-.242Zm4.001 0c0-.117.11-.25.254-.25a.23.23 0 0 1 .238.25c-.006.145-.074.242-.238.242-.125 0-.254-.125-.254-.242Zm3.996 0c0-.117.11-.25.254-.25a.23.23 0 0 1 .238.25c-.006.145-.074.242-.238.242-.125 0-.254-.125-.254-.242Zm4.001 0c0-.117.11-.25.254-.25a.23.23 0 0 1 .238.25c-.006.145-.074.242-.238.242-.125 0-.254-.125-.254-.242Zm4.006 0c0-.117.11-.25.254-.25a.23.23 0 0 1 .238.25c-.006.145-.074.242-.238.242-.125 0-.254-.125-.254-.242Zm-2.01 2.998c0-.117.109-.25.253-.25a.23.23 0 0 1 .239.25c-.006.145-.075.242-.239.242-.125 0-.254-.125-.254-.242Zm-3.997 0c0-.117.11-.25.254-.25a.23.23 0 0 1 .239.25c-.006.145-.075.242-.239.242-.125 0-.254-.125-.254-.242Zm-3.99 0c0-.117.11-.25.254-.25a.23.23 0 0 1 .238.25c-.006.145-.074.242-.238.242-.125 0-.254-.125-.254-.242Zm-4.012 0c0-.117.11-.25.254-.25a.23.23 0 0 1 .238.25c-.006.145-.074.242-.238.242-.125 0-.254-.125-.254-.242Z"
    />
  </svg>
)
export default dismiss_keyboard_medium
